import { BlueprintDeployment, StackOutput } from "types/generated";

export type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
};

export const getDeploymentOutputs = (deployment: BlueprintDeployment): OutputWithStack[] => {
  const allOutputs: OutputWithStack[] = [];

  deployment.stacks.forEach((stack) => {
    stack.outputs.forEach((output) => {
      allOutputs.push({
        ...output,
        stackId: stack.id,
        stackName: stack.name,
      });
    });
  });

  return allOutputs;
};
